export default "__VITE_ASSET__DqvaZXfM__"